export type AnalyticsIds = {
  page?: string | null;
  feature?: string | null;
};

const kebab = (s: string) =>
  String(s || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export function analyticsIdsFromPathname(pathname: string): AnalyticsIds {
  const raw = String(pathname || "/");
  const parts = raw.split("?")[0].split("#")[0].split("/").filter(Boolean);

  if (parts.length === 0) return { feature: "dashboard", page: "dashboard" };

  const [root, second] = parts;

  if (root === "reports") {
    if (second === "attendance") return { feature: "attendance", page: "attendance-overview" };
    if (second === "privacy") return { feature: "privacy", page: "privacy-overview" };
    if (second === "students") return { feature: "reports", page: "reports-students" };
    if (second === "alumni") return { feature: "alumni", page: "alumni-overview" };
    if (second === "analytics") return { feature: "admin", page: "analytics-usage" };
    return { feature: "reports", page: "reports" };
  }

  if (root === "portal") {
    const rest = parts.slice(1).filter(Boolean).join("-");
    return {
      feature: "parent-portal",
      page: kebab(`portal-${rest || "home"}`),
    };
  }

  if (root === "family") {
    if (second === "children") return { feature: "family", page: "children-list" };
    if (second === "parents") return { feature: "family", page: "parents-list" };
    if (second === "families") return { feature: "family", page: "families-list" };
    return { feature: "family", page: kebab(`family-${second || "overview"}`) };
  }

  if (root === "school") {
    if (second === "classrooms") return { feature: "school", page: "classrooms" };
    if (second === "years") return { feature: "school", page: "school-years" };
    if (second === "teachers") return { feature: "school", page: "teachers" };
    if (second === "waiting-list") return { feature: "school", page: "waiting-list" };
    return { feature: "school", page: kebab(`school-${second || "overview"}`) };
  }

  if (root === "admin") {
    return { feature: "admin", page: kebab(`admin-${second || "overview"}`) };
  }

  if (root === "maintenance") {
    return { feature: "admin", page: kebab(`maintenance-${second || "overview"}`) };
  }

  if (root === "noctis") {
    return { feature: "admin", page: "noctis" };
  }

  if (root === "dashboard") return { feature: "dashboard", page: "dashboard" };

  return { feature: kebab(root), page: kebab([root, second].filter(Boolean).join("-")) || kebab(root) };
}
